import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { getClubEvent, addClubEventMember, removeClubEventMember} from '../../../api/ClubEventsAPI';
import { getUsers } from '../../../api/UsersAPI';
import AppBreadCrumb from '../../common/AppBreadCrumb';
import Swal from 'sweetalert2';

const ClubEventManagePage = () => {
    const { clubEventId } = useParams();
    const [event, setEvent] = useState(null);
    const [allMembers, setAllMembers] = useState([]);
    const [memberToAdd, setMemberToAdd] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const fetchEventData = () => {
        getClubEvent(clubEventId, (data) => {
            setEvent(data);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        fetchEventData();
        // Fetch all users for the dropdown
        getUsers({ paginate: false }, (data) => {
            if (data.users) setAllMembers(data.users);
        });
    }, [clubEventId]);

    const handleAddMember = () => {
        if (!memberToAdd) return;
        addClubEventMember(clubEventId, memberToAdd.value, (updatedMembers) => {
            setEvent(prev => ({ ...prev, members: updatedMembers }));
            setMemberToAdd(null);
        });
    };
    
    const handleRemoveMember = (userId) => {
        removeClubEventMember(clubEventId, userId, (updatedMembers) => {
            Swal.fire('Removed!', 'The member has been removed from the event.', 'success');
            setEvent(prev => ({ ...prev, members: updatedMembers }));
        });
    };

    const memberOptions = allMembers
        .filter(user => !event?.members.some(member => member.id === user.id))
        .map(user => ({ value: user.id, label: user.name }));

    if (isLoading || !event) return <div className="text-center p-5"><div className="spinner-border"></div></div>;

    return (
        <main>
            <div className="container-fluid">
                <AppBreadCrumb title={`Manage Members: ${event.name}`} />
                <div className="card">
                    <div className="card-header"><h5>Add Members to Event</h5></div>
                    <div className="card-body">
                        <div className="input-group">
                            <Select
                                className="flex-grow-1"
                                options={memberOptions}
                                value={memberToAdd}
                                onChange={setMemberToAdd}
                                placeholder="Select a club member to add..."
                            />
                            <button className="btn btn-primary" onClick={handleAddMember} disabled={!memberToAdd}>Add Member</button>
                        </div>
                    </div>
                </div>

                <div className="card mt-4">
                    <div className="card-header"><h5>Current Members ({event.members.length})</h5></div>
                    <div className="card-body">
                        <ul className="list-group">
                            {event.members.map(member => (
                                <li key={member.id} className="list-group-item d-flex justify-content-between align-items-center">
                                    {member.name}
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleRemoveMember(member.id)}>Remove</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ClubEventManagePage;